export const DASHBOARD_SIGNUP_URL = "https://dashboard.10k.science/signup";
export const META_QUEST_STORE_URL = "https://vr.meta.me/s/AgoyeP9cC8NV2jI";
export const WEB_VIEWER_URL = "https://viewer.10k.science";

export const IOS_APP_STORE_ID = "6793177913";
export const IOS_APP_STORE_URL =
  "https://apps.apple.com/us/app/10k-science/id6793177913";
export const IOS_LAUNCH_ANCHOR_ID = "ios-launch";
export const IOS_LAUNCH_PATH = `/#${IOS_LAUNCH_ANCHOR_ID}`;
export const IOS_APP_DESTINATION_URL = IOS_APP_STORE_URL;

export const IOS_BANNER_BACKGROUND_URL =
  "/assets/ios/ios-ipad-hero-banner.webp";
